<template>
	<div class="d-flex flex-column flex h100">
		<navbar></navbar>
		<div class="app">
			<config-sidenav></config-sidenav>
			<div id="content" class="app-content box-shadow-3 w-100">
				<div class="navbar navbar-expand-lg">
					<!-- Page title -->
					<loading type="header" v-if="loading" />
					<div v-if="!loading" class="navbar-text nav-title flex" id="pageTitle">{{ client.name }}</div>
				</div>

				<div class="content-main" style="background-color:white;">
					<!-- Page content goes here -->
					<div class="h-100" v-if="!loading">
						<div class="d-sm-flex b-t h-100">
							<div class="w w-auto-xs light bg b-r" style="box-sizing: content-box;">
								<div class="py-3">
									<div class="nav-active-border left b-primary">
										<!-- Nav by page -->
										<ul class="nav flex-column nav-sm">
											<li class="nav-item">
												<a
													class="nav-link"
													:class="{ active: tab == 1, show: tab == 1 }"
													href="#"
													data-toggle="tab"
													data-target="#tab-1"
												>
													Setup
													<i
														class="valid-hint text fa fa-angle-left"
														:class="{ invalid: !valid.group('setup') }"
													></i>
												</a>
											</li>
										</ul>
									</div>
								</div>
							</div>
							<edit-pane
								class="scroll-x"
								style="width: 100%"
								:cancel="loadData"
								:save="saveClient"
								:dirty="dirty"
								:valid="valid"
							>
								<div class="tab-content h-100" ref="content">
									<!-- Overall Settings -->
									<div class="tab-pane" :class="{ active: tab == 1, show: tab == 1 }" id="tab-1">
										<div class="p-4 b-b _600 nav-title">Setup</div>
										<div class="row m-0">
											<form role="form" class="p-4 col-sm-6">
												<div class="form-group" :class="{ invalid: !valid.field('name') }">
													<label>Tenant Name</label>
													<input type="text" class="form-control" v-model="client.name" />
												</div>
												<div
													class="form-group"
													:class="{
														invalid: !valid.field('ref') || !valid.field('ref_char')
													}"
												>
													<label>Reference ID</label>
													<input
														type="text"
														class="form-control"
														v-model.trim="client.ref_id"
													/>
													<small class="form-text text-muted"
														>Reference ID must be unique</small
													>
												</div>
												<div class="form-group">
													<label>Registration Embed Link</label>
													<input
														type="url"
														class="form-control"
														:value="`${client.host}/v3/registration/${client.ref_id}`"
														readonly
													/>
												</div>
												<div class="form-group" v-if="client.survey_enabled">
													<label>Survey URL</label>
													<input
														type="url"
														class="form-control"
														v-model="client.survey_url"
													/>
												</div>
												<div class="form-group">
													<label>Brand Name:</label>
													<input
														type="url"
														class="form-control"
														v-model="client.brand_name"
													/>
												</div>
																			<div class="form-group">
													<label>Host:</label>
													<input
														type="url"
														class="form-control"
														v-model="client.host"
													/>
												</div>
											</form>
											<form role="form" class="p-4 col-sm-6">
												<label>Send Scoring Reminder Email</label>
												<div class="row">
													<div class="form-group col-6">
														<config-select
															:options="weekdays"
															sortBy="value"
															byField="value"
															v-model="client.response_scan_day"
															label="name"
														></config-select>
													</div>
													<div class="form-group col-6">
														<date-picker
															v-model="client.response_scan_time"
															:config="timeConfig"
														></date-picker>
													</div>
												</div>
												<!-- Time Zone -->
												<div class="form-group">
													<label>Time Zone</label>
													<v-select :options="timezones" v-model="timezone"></v-select>
												</div>

												<div class="checkbox form-group">
													<label class="md-check">
														<input type="checkbox" v-model="client.survey_enabled" />
														<i class="theme-accent"></i> Survey Enabled
													</label>
												</div>
												<div class="checkbox form-group">
													<label class="md-check">
														<input type="checkbox" v-model="client.terms_required" />
														<i class="theme-accent"></i> Terms Required
													</label>
												</div>
												<div class="checkbox form-group">
													<label class="md-check">
														<input type="checkbox" v-model="client.assessment_purpose" />
														<i class="theme-accent"></i> Assessment Purpose
													</label>
												</div>												
												<div class="checkbox form-group">
													<label class="md-check">
														<input type="checkbox" v-model="client.essential_skills" />
														<i class="theme-accent"></i> Essential Skills
													</label>
												</div>
													<div class="checkbox form-group">
													<label class="md-check">
														<input type="checkbox" v-model="client.standards_rubric" />
														<i class="theme-accent"></i> Standards Rubric
													</label>
												</div>
													<div class="checkbox form-group">
													<label class="md-check">
														<input type="checkbox" v-model="client.assessments_upload" />
														<i class="theme-accent"></i> Assessments Upload
													</label>
												</div>
											</form>
				
											<form
												role="form"
												class="px-4 pb-4 pt-0 col-12"
												v-if="client.terms_required"
											>
												<div class="form-group">
													<div class="d-flex flex-row">
														<label style="width: 50%">Terms:</label>
														<span
															v-if="client.terms_required && termsChanged && !firstTerms"
															class="checkbox pl-4"
														>
															<label
																class="md-check"
																v-tippy="{ theme: 'popover' }"
																title="Users will have to accept the updated terms even if they've accepted a previous version"
															>
																<input v-model="reacceptTerms" type="checkbox" />
																<i class="theme-accent"></i> Force Re-Accept
															</label>
														</span>
													</div>
													
													<RichText
														:text.sync="client.terms_text"
														:initial="originalTermsText"
														:refresh="refresh"
													></RichText>
												</div>
											</form>
										</div>
									</div>
								</div>
							</edit-pane>
							<save-optional-modal
								:dirty="dirty"
								:valid="valid"
								:save="saveClient"
								:next="saveOptNext"
								:cancel="saveOptCancel"
								objectText="Tenant"
								:objectName="client.name"
								actionText="leave the page"
								v-model="saveOptModal"
							/>

							<save-required-modal
								:dirty="dirty"
								:valid="valid"
								:save="saveClient"
								:next="saveReqNext"
								objectText="Tenant"
								:objectName="client.name"
								:actionText="saveReqAction"
								v-model="saveReqModal"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Add Credential Modal -->
		<div
			class="modal fade"
			id="exampleModal"
			tabindex="-1"
			role="dialog"
			aria-labelledby="exampleModalLabel"
			aria-hidden="true"
		>
			<div class="modal-dialog modal-dialog-centered" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5>New Credential</h5>
					</div>
					<div class="modal-body">
						<div autocomplete="off" class="p-1 col-sm-12">
							<div class="form-group">
								<label>Credential ID</label>
								<input type="text" class="form-control" v-model="newCredential.cred_id" />
							</div>
							<div class="form-group">
								<label>type</label>
								<input
									type="text"
									disabled="disabled"
									class="form-control"
									v-model="newCredential.type"
								/>
							</div>
							<div class="form-group">
								<label>Key</label>
								<input type="text" class="form-control" v-model="newCredential.key" />
							</div>
							<div class="form-group">
								<label>Secret</label>
								<input
									autocomplete="off"
									type="password"
									class="form-control"
									v-model="newCredential.secret"
								/>
							</div>
							<div class="form-group">
								<label>Bucket</label>
								<input
									autocomplete="off"
									type="text"
									class="form-control"
									v-model="newCredential.bucket"
								/>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary danger" data-dismiss="modal">Close</button>
						<button type="button" class="btn btn-primary" data-dismiss="modal" @click="saveCredential()">
							Save changes
						</button>
					</div>
				</div>
			</div>
		</div>

		<mzfooter></mzfooter>
	</div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bg-auto {
	z-index: -1;
}
.w30 {
	width: 30px;
}
</style>

<script>
//Libraries
import notie from "@/services/NotieService";

//Services
import TenantService from "@/services/TenantService";
import AuthService from "@/services/AuthService";
import ValidationService from "@/services/ValidationService";
import ThemeService from "@/services/ThemeService";
import fs from "@/services/FormatService";
import Utils from "@/services/Utils";
import moment from "moment";

//Components
import EditPane from "@/components/EditPane";
import DualTable from "@/components/DualTable";
import SaveOptionalModal from "@/components/SaveOptionalModal";
import SaveRequiredModal from "@/components/SaveRequiredModal";
import RichText from "@/components/RichText";
import "eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css";
import DatePicker from "vue-bootstrap-datetimepicker";
import ConfigSelect from "@/components/ConfigSelect";

const timeFormat = "h:mm A";
const timeConfig = {
	format: timeFormat,
	icons: {
		time: "fa fa-clock-o",
		date: "fa fa-calendar",
		up: "fa fa-chevron-up",
		down: "fa fa-chevron-down",
		previous: "fa fa-chevron-left",
		next: "fa fa-chevron-right",
		today: "fa fa-sun-o",
		clear: "fa fa-trash",
		close: "fa fa-remove"
	}
};

const weekdays = [
	{ value: 0, name: "Sunday" },
	{ value: 1, name: "Monday" },
	{ value: 2, name: "Tuesday" },
	{ value: 3, name: "Wednesday" },
	{ value: 4, name: "Thursday" },
	{ value: 5, name: "Friday" },
	{ value: 6, name: "Saturday" }
];

export default {
	name: "TenantEdit",

	components: {
		EditPane,
		DualTable,
		SaveOptionalModal,
		SaveRequiredModal,
		RichText,
		DatePicker,
		ConfigSelect
	},

	props: ["user", "params", "query"],

	data() {
		return {
			fs: fs,
			timeConfig: timeConfig,
			tab: 1,
			mode: "",
			client: {},
			loading: true,
			successMsg: "",
			errMsg: "",
			dirty: false,
			credentials: [],
			newCredential: {},

			reacceptTerms: false,
			originalTermsText: "",
			refresh: null,

			hasFields: [
				{
					key: "name",
					label: this.$i18n.t("label.name"),
					sortable: true
				},
				{
					key: "role",
					thStyle: { width: "33%" },
					tdStyle: { width: "33%" },
					tdClass: "p-custom py-0 v-mid condensed-v-select"
				},
				{
					key: "actions",
					label: this.$i18n.t("label.actions"),
					thStyle: { "text-align": "center" },
					tdClass: "p-custom py-0 v-mid",
					sortable: true
				}
			],
			hasControl: {
				totalRows: 0,
				currentPage: 1,
				perPage: 20,
				filter: "",
				sortBy: "",
				sortDesc: false,
				emptyText: ""
			},
			hasBusy: false,
			canFields: [
				{
					key: "name",
					label: this.$i18n.t("label.name"),
					sortable: true
				},
				{
					key: "import_as",
					thStyle: { width: "33%" },
					tdStyle: { width: "33%" },
					tdClass: "p-custom py-0 v-mid condensed-v-select"
				},
				{
					key: "actions",
					label: this.$i18n.t("label.actions"),
					thStyle: { "text-align": "center" },
					tdClass: "p-custom py-0 v-mid",
					sortable: true
				}
			],
			canControl: {
				totalRows: 0,
				currentPage: 1,
				perPage: 20,
				filter: "",
				sortBy: "",
				sortDesc: false,
				emptyText: ""
			},

			timezones: fs.timezones,
			timezone: null,
			weekdays: weekdays,

			scanIntervals: fs.scanIntervals,
			scanInterval: null,
			scanRoles: [],

			valid: {},
			saveOptModal: false,
			saveOptNext: () => {},
			saveOptCancel: () => {},

			saveReqModal: false,
			saveReqAction: "continue",
			saveReqNext: () => {}
		};
	},

	created() {
		this.loadData();
		this.initValidation();

		if (this.query.tab) {
			this.tab = this.query.tab;
		}
	},

	watch: {
		"client.name"() {
			if (this.autoRef) {
				this.client.ref_id = this.generateAutoRef(this.client.name);
			}
		},
		"client.ref_id"() {
			this.checkAutoRef();
		},
		timezone() {
			console.log("Change timezone to", this.timezone);
			if (this.timezone && this.client.timezone != this.timezone.string) {
				this.client.timezone = this.timezone.string;
			}
		},
		scanInterval() {
			console.log("Change scan interval to", this.scanInterval);
			if (this.scanInterval && this.client.new_responses_interval != this.scanInterval) {
				this.client.new_responses_interval = this.scanInterval.string;
			}
		},
		scanRoles() {
			_.each(this.client.roles, role => {
				let enabled = _.find(this.scanRoles, { id: role.id });
				if (enabled) {
					role.receive_new_responses_emails = true;
				} else {
					role.receive_new_responses_emails = false;
				}
			});
		}
	},

	computed: {
		orderedRoles() {
			return _.orderBy(this.client.roles, ["access", "name"], ["desc", "asc"]);
		},
		accessibleRoles() {
			return _.filter(this.client.roles, role => {
				return this.user.role.access >= role.access;
			});
		},
		firstTerms() {
			console.log("updated year", moment(this.client.terms_updated_at).year());
			return moment(this.client.terms_updated_at).year() == 0;
		},
		termsChanged() {
			return this.client.terms_text != this.originalTermsText;
		},
		showScanRoles() {
			return this.scanInterval && (this.scanInterval.string == "daily" || this.scanInterval.string == "hourly");
		},
		showScanTime() {
			return this.scanInterval && this.scanInterval.string == "daily";
		}
	},

	beforeRouteLeave(to, from, next) {
		if (this.dirty) {
			this.saveOptNext = () => {
				next();
			};
			this.saveOptCancel = () => {
				next(false);
			};
			this.saveOptModal = true;
		} else {
			next();
		}
	},

	methods: {
		initValidation() {
			this.valid = ValidationService.newValidator({
				name: {
					group: "setup",
					errorMsg: "You must assign a name",
					func: () => {
						return this.client && this.client.name && this.client.name != "";
					}
				},
				ref: {
					group: "setup",
					errorMsg: "You must assign a reference ID",
					func: () => {
						return this.client && this.client.ref_id && this.client.ref_id != "";
					}
				},
				ref_char: {
					group: "setup",
					errorMsg:
						"Reference IDs may not contain spaces or any of the following characters: ! # % ^ * ( )  / [ ] { } < > ? | ' \" :",
					func: () => {
						return this.client && this.client.ref_id && fs.isGoodRefID(this.client.ref_id);
					}
				}
			});
		},

		blankClient() {
			return {
				roles: [
					RoleService.getPrefillRole("DIRECTOR"),
					RoleService.getPrefillRole("ADMIN"),
					RoleService.getPrefillRole("RESOLUTION"),
					RoleService.getPrefillRole("TEAM_LEAD"),
					RoleService.getPrefillRole("SCORER"),
					RoleService.getPrefillRole("BASIC_SCORER")
				],
				alerts: [],
				credentials: []
			};
		},

		watchChanges() {
			if (this.unwatch) {
				this.unwatch();
			}
			this.unwatch = this.$watch(
				"client",
				(newc, old) => {
					console.log(newc, old);
					console.log("marking dirty");
					this.dirty = true;
				},
				{ deep: true }
			);
		},

		loadData() {
			this.dirty = false;

			ThemeService.getThemes().then(themes => {
				this.themes = themes;
			});

			var reqId = "";
			if (this.params.id != "current") {
				reqId = this.params.id;
			}

			if (this.params.id != "new") {
				return TenantService.getClient(reqId).then(resp => {
					this.client = resp.data;
					if (this.client.roles.length > 0) {
						this.sRole = _.find(_.orderBy(this.client.roles, ["access", "name"], ["desc", "asc"]), role => {
							return this.user.role.access >= role.access;
						});
						this.loading = false;
						this.originalTermsText = this.client.terms_text;
						if (!this.client.timezone) {
							this.$set(this.client, "timezone", "America/New_York");
						}
						if(!this.client.assessment_purpose){
							this.client.assessment_purpose = false
						}
						if(!this.client.essential_skills){
							this.client.essential_skills = false
						}
						if(this.client.standards_rubric != true){
							this.client.standards_rubric = false
						}
						if(this.client.assessments_upload != true){
							this.client.assessments_upload = false
						}
						this.timezone = _.find(this.timezones, {
							string: this.client.timezone
						});
						this.scanInterval = _.find(this.scanIntervals, {
							string: this.client.new_responses_interval
						});

						this.scanRoles = [];
						_.each(this.client.roles, role => {
							if (role.receive_new_responses_emails) {
								console.log("ROLE", role.id, "HAD PERM");
								this.scanRoles.push(role);
							}
						});

						this.refresh = new Date();
						this.checkAutoRef();
						this.watchChanges();

						TenantService.listCredentials(this.client.id).then(resp => {
							this.credentials = resp.data;
						});
					}
				});
			} else {
				return TenantService.getEmptyClient().then(resp => {
					this.client = resp.data;
					this.sRole = this.client.roles[0];
					this.loading = false;
					this.$set(this.client, "name", "New Client");
					this.$set(this.client, "ref_id", "new_client");

					this.$set(this.client, "timezone", "America/New_York");
					this.timezone = _.find(this.timezones, {
						string: this.client.timezone
					});

					this.$set(this.client, "new_responses_interval", "hourly");
					this.scanInterval = _.find(this.scanIntervals, {
						string: this.client.new_responses_interval
					});

					this.scanRoles = [];

					this.$set(this.client, "new_responses_time", "9:00 PM");

					this.watchChanges();
				});
			}
		},

		saveClient() {
			AuthService.queueRefresh();
			if (this.client.terms_required) {
				if (this.firstTerms) {
					this.client.terms_updated_at = moment();
					this.client.terms_updated_at.year(1);
				}
				if (this.reacceptTerms) {
					this.client.terms_updated_at = moment();
				}
			}
			return TenantService.saveClient(this.client)
				.then(resp => {
					notie.success("Tenant saved");
					if (this.client.id != resp.data.id) {
						this.$router.replace("/tenants/" + resp.data.id);
					}
					// else {
					// 	this.$router.replace(
					// 		"/tenants/" +
					// 			resp.data.id +
					// 			"?rand=" +
					// 			Math.floor(Math.random() * 1000000)
					// 	);
					// }
					this.loadData();
					ThemeService.refresh();
				})
				.catch(err => {
					notie.error("Failed to save tenant", err);
				});
		},

		removeFlag(flag) {
			this.client.alerts = _.without(this.client.alerts, flag);
		},

		isRoleActive(role) {
			if (role && this.sRole) {
				return this.sRole.id == role.id;
			} else {
				return false;
			}
		},

		addCredential() {
			// debugger;
			console.log("opening");
			this.newCredential = {
				client_id: this.client.id,
				type: "S3"
			};
		},

		saveCredential() {
			TenantService.saveCredential(this.newCredential)
				.then(resp => {
					this.loadData();
				})
				.catch(err => {
					notie.error("Failed to save credential", err);
				});
		},

		removeCredential(credential) {
			TenantService.removeCredential(credential.id).then(resp => {
				this.loadData();
			});
		},

		// Convenience method to scroll a heading into view.
		// Not required for scrollspy to work
		scrollIntoView(evt) {
			evt.preventDefault();
			const href = evt.target.getAttribute("href");
			const el = href ? document.querySelector(href) : null;
			if (el) {
				this.$refs.content.scrollTop = el.offsetTop;
			}
		},

		getRoleName(roleId) {
			var role = _.find(this.client.roles, { id: roleId });
			return (role && role.name) || "Undefined";
		},

		refreshTables() {
			this.$root.$emit("bv::refresh::table", "leftTable");
			this.$root.$emit("bv::refresh::table", "rightTable");
		},

		checkAutoRef() {
			let genRef = this.generateAutoRef(this.client.name);
			this.autoRef = this.client.ref_id == genRef;
		},

		generateAutoRef(name) {
			return name && fs.toGoodRefID(name);
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/vues/SetupConfig/TenantEdit.vue